module.exports = __webpack_public_path__ + "img/hips.128432c3.png";